'use strict';

var hexToRgba$1 = require('../../../../../../../../../_virtual/hexToRgba.cjs');

const validHexRegex = new RegExp(/^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})?$/i);
/**
 * Give a HEX color code, converts it to an equivalent RGB color code.
 */ const hexToRgb = (hex)=>hexToRgba(hex, 1, true);
/**
 * Give a HEX color code, converts it to an equivalent RGBA color code.
 */ const hexToRgba = (hex, opacity, omitAlpha = false, removeAlphaFloat = false)=>{
    const result = validHexRegex.exec(hex);
    if (!result) return "";
    const hexWithoutHash = hex.replace(/^#/, "");
    // Parse r, g, b values
    const r = parseInt(hexWithoutHash.slice(0, 2), 16);
    const g = parseInt(hexWithoutHash.slice(2, 4), 16);
    const b = parseInt(hexWithoutHash.slice(4, 6), 16);
    if (omitAlpha) return `rgb(${r}, ${g}, ${b})`;
    let alpha = 1.0; // Default to fully opaque
    if (hexWithoutHash.length === 8) {
        alpha = parseInt(hexWithoutHash.slice(6, 8), 16) / 255;
    }
    // If an opacity argument is provided, it overrides the alpha value from the HEX code
    if (typeof opacity === "number") {
        alpha = Math.max(0, Math.min(1, opacity));
    }
    // Return the RGBA representation
    if (removeAlphaFloat) return `rgba(${r}, ${g}, ${b}, ${alpha.toFixed(0)})`;
    return `rgba(${r}, ${g}, ${b}, ${alpha.toFixed(1)})`;
};

hexToRgba$1.__exports.hexToRgb = hexToRgb;
hexToRgba$1.__exports.hexToRgba = hexToRgba;

module.exports = hexToRgba$1.__exports;
//# sourceMappingURL=hexToRgba.cjs.map
